import React from 'react';
import { IconButton as MuiIconButton, IconButtonProps as MuiIconButtonProps, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

import styles from './IconButton.styles';

export type IconButtonProps =
Pick<MuiIconButtonProps,
'children' | 'className' | 'aria-label' | 'onClick' | 'buttonRef' | 'disabled' | 'title'>
& { 'data-xpath'?: string, size?: 'large' | 'medium' | 'small' };

const useStyles = makeStyles(styles, { name: 'IconButton' });

export default function IconButton({
  className, children, buttonRef, 'aria-label': ariaLabel, onClick, disabled, 'data-xpath': dataXpath, title,
  size = 'medium',
} : IconButtonProps) {
  const classes = useStyles();

  return (
    <MuiIconButton
      className={clsx(className, classes.root, {
        [classes.disabled]: disabled,
        [classes.large]: size === 'large',
        [classes.medium]: size === 'medium',
        [classes.small]: size === 'small',
      })}
      aria-label={ariaLabel}
      edge="start"
      disableRipple
      color="inherit"
      buttonRef={buttonRef}
      onClick={onClick}
      disabled={disabled}
      data-xpath={dataXpath}
      title={title}
    >
      {children}
    </MuiIconButton>
  );
}
